import { z } from 'zod'

/**
 * Who asked a vendor for a quote, as the vendor is told: the couple, its
 * planner, or the venue's staff. Mirrors the Prisma `QuoteRequesterRole` enum
 * (`check:enums`).
 */
export const QUOTE_REQUESTER_ROLES = ['couple', 'planner', 'venue'] as const

export const quoteRequesterRoleSchema = z.enum(QUOTE_REQUESTER_ROLES)

export type QuoteRequesterRole = z.infer<typeof quoteRequesterRoleSchema>
